import React from "react";
import { MapPin, Navigation, Phone } from "lucide-react";

export const LocationMap = () => {
  return (
    <section
      id="location"
      className="py-16 bg-gradient-to-b from-white via-teal-50/40 to-white"
      data-testid="location-map-section"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section heading */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-xs font-semibold mb-3 tracking-wide uppercase">
            <MapPin className="h-3.5 w-3.5" />
            Find Us
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
            Visit Barnston Court Nursing Home
          </h2>
          <p className="text-sm md:text-base text-gray-600 max-w-xl mx-auto">
            Conveniently located in Moreton, Wirral. Visits welcome seven days a week.
          </p>
        </div>

        {/* Compact, stylish map card */}
        <div className="relative group">
          {/* decorative gradient ring */}
          <div className="absolute -inset-0.5 bg-gradient-to-r from-teal-400 via-teal-500 to-orange-400 rounded-2xl blur opacity-30 group-hover:opacity-50 transition-opacity"></div>

          <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden ring-1 ring-gray-200/60">
            {/* Map */}
            <div className="relative h-64 sm:h-72 md:h-80 bg-gray-100">
              <iframe
                src="https://maps.google.com/maps?q=21%20Barnston%20Lane%2C%20Moreton%2C%20Wirral%20CH46%207TN&t=&z=16&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Barnston Court Nursing Home Location"
                data-testid="location-map-iframe"
              ></iframe>

              {/* Floating address pill */}
              <div className="absolute top-3 left-3 bg-white/95 backdrop-blur-sm rounded-xl shadow-lg p-2.5 pointer-events-none hidden sm:flex items-center gap-2 max-w-[260px] ring-1 ring-gray-200/60">
                <div className="bg-teal-600 text-white p-1.5 rounded-lg flex-shrink-0">
                  <MapPin className="h-4 w-4" />
                </div>
                <div className="min-w-0">
                  <p className="font-semibold text-gray-900 text-xs leading-tight truncate">
                    Barnston Court Nursing Home
                  </p>
                  <p className="text-[11px] text-gray-600 mt-0.5 leading-tight">
                    21 Barnston Lane, CH46 7TN
                  </p>
                </div>
              </div>
            </div>

            {/* Action bar */}
            <div className="grid grid-cols-2 divide-x divide-gray-200 bg-white">
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=21+Barnston+Lane+Moreton+Wirral+CH46+7TN"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Open Barnston Court location in Google Maps"
                className="flex items-center justify-center gap-2 text-teal-700 hover:text-white hover:bg-teal-600 py-3 px-4 text-sm font-semibold transition-all"
                data-testid="location-map-directions-btn"
              >
                <Navigation className="h-4 w-4" />
                <span>Directions</span>
              </a>
              <a
                href="tel:01516775573"
                aria-label="Call Barnston Court Nursing Home"
                className="flex items-center justify-center gap-2 text-orange-600 hover:text-white hover:bg-orange-500 py-3 px-4 text-sm font-semibold transition-all"
                data-testid="location-map-call-btn"
              >
                <Phone className="h-4 w-4" />
                <span>0151 677 5573</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
